import { getCookie, deleteCookie } from "Functions/cookie";

// Legacy path for the Median/GoNative apps and the old custom B2B Flutter wrapper
// (window.FlutterApp). The Riesenia wrapper handles the same cookie through the
// canonical glue (common/app/app-logout.js → bridge CLEAR_SESSION), so bail out
// there — otherwise this would delete the cookie before that glue reads it.
const isWrapperApp = Boolean(window.AppBridge && window.AppBridge.isApp);

// Check for logged_out cookie and notify Flutter WebView
if (!isWrapperApp && getCookie("logged_out")) {
    // Notify Flutter WebView to clear data
    if (window.notifyLogout) {
        window.notifyLogout();
    }

    // Delete the cookie so it doesn't trigger again
    deleteCookie("logged_out");
}
